"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = void 0;
/* eslint-disable no-console */
const ZForm_1 = require("./ZForm");
const useWhyDidYouUpdate_1 = require("../../utils/useWhyDidYouUpdate");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const use_reducer_with_side_effects_1 = __importStar(require("use-reducer-with-side-effects"));
const validate = (state) => {
    return !lodash_1.default.some(state.fields, field => !field.valid);
};
const getInitialFormState = (fields, debug = false) => {
    if (debug) {
        console.group("getInitialFormState");
        console.log(fields);
    }
    const result = {
        valid: false,
        touched: false,
        submitted: false,
        fields: lodash_1.default.fromPairs(react_1.default.Children.toArray(fields).map((child) => {
            if (debug) {
                console.log(child);
            }
            return (child && [
                child.props.id || child.props.label,
                {
                    value: child.props.value || child.props.defaultValue || "",
                    valid: child.props.required !== true ||
                        !!child.props.value ||
                        child.props.value === 0 ||
                        !!child.props.defaultValue ||
                        child.props.defaultValue === 0,
                    touched: false,
                    required: child.props.required ? true : false,
                    hidden: child.props.hidden ? true : false
                }
            ]);
        }))
    };
    if (debug) {
        console.log(result);
        console.groupEnd();
    }
    return result;
};
exports.useForm = (args) => {
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("useForm", args);
    const { fields } = args;
    const { onFormChange, debug } = react_1.default.useContext(ZForm_1.FormContext);
    const formReducer = react_1.default.useCallback((state, action) => {
        if (!action)
            return state;
        if (debug) {
            console.log("old state: ", { ...state });
            console.log(`action: ${action.type.toUpperCase()}`);
        }
        if (action.type === "updateFieldVis") {
            const newState = {
                ...state,
                fields: Object.keys(state.fields).reduce((allFields, field) => {
                    const matchingField = lodash_1.default.flatten(action.payload).find((f) => f.props.id === field || f.props.label === field);
                    const requiredProp = matchingField
                        ? matchingField.props.required
                        : false;
                    allFields[field].required = requiredProp;
                    const hiddenProp = matchingField
                        ? matchingField.props.hidden
                        : false;
                    allFields[field].hidden = hiddenProp;
                    allFields[field].valid =
                        requiredProp !== true ||
                            !!state.fields[field].value ||
                            state.fields[field].value === 0;
                    return allFields;
                }, { ...state.fields })
            };
            const isFormValid = validate(newState);
            newState.valid = isFormValid;
            if (debug) {
                console.log(`form ${isFormValid}: ${JSON.stringify(newState.valid)}`);
            }
            return use_reducer_with_side_effects_1.Update(newState);
        }
        if (action.type === "update") {
            const newState = {
                valid: false,
                submitted: false,
                touched: true,
                fields: Object.keys(state.fields).reduce((allFields, field) => {
                    if (field === action.payload.field) {
                        allFields[field].touched = action.payload.touch;
                        allFields[field].value = action.payload.value;
                        allFields[field].valid =
                            state.fields[field].required !== true ||
                                !!action.payload.value ||
                                action.payload.value === 0;
                        allFields[field].required =
                            state.fields[field].required;
                        allFields[field].hidden = state.fields[field].hidden;
                    }
                    else {
                        allFields[field] = state.fields[field];
                    }
                    return allFields;
                }, { ...state.fields })
            };
            const isFormValid = validate(newState);
            newState.valid = isFormValid;
            if (debug) {
                console.log(`form ${isFormValid}: ${JSON.stringify(newState.valid)}`);
            }
            return use_reducer_with_side_effects_1.UpdateWithSideEffect(newState, (updatedState) => {
                onFormChange &&
                    onFormChange(updatedState.valid, updatedState.fields);
                if (debug) {
                    console.log("new state: ", { ...updatedState });
                }
            });
        }
        return use_reducer_with_side_effects_1.NoUpdate();
    }, [onFormChange, debug]);
    const [formState, formDispatch] = use_reducer_with_side_effects_1.default(formReducer, getInitialFormState(fields, debug));
    react_1.default.useEffect(() => {
        formDispatch({ type: "updateFieldVis", payload: fields });
    }, [fields, formDispatch]);
    return {
        formState,
        formDispatch
    };
};
//# sourceMappingURL=formValidation.js.map